import { inject, Injectable } from "@angular/core";
import { PWAService } from "src/app/services/pwa.service";
import { PLATFORM_TOKEN } from "src/app/tokens/platform.token";
import { PlatformType } from "src/app/common/platform-type";

@Injectable()
export class EnablePWAGuard {
  private readonly PLATFORM = inject(PLATFORM_TOKEN);
  private readonly pwaService = inject(PWAService);

  async canActivate(): Promise<boolean> {
    switch (this.PLATFORM) {
      case PlatformType.DESKTOP: {
        break;
      }
      case PlatformType.MOBILE: {
        // TODO abilitare PWA
        //this.pwaService.start();
        break;
      }
    }

    return true;
  }
}
